<gs-brand-screen-message [message]="'page.notFound' | translate" />
